import React from "react";
import { Tv } from "lucide-react";

export function Logo({ size = 22, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className="tv-gradient flex items-center justify-center rounded-xl text-[#04201c] shadow-lg shadow-tv-teal/20"
        style={{ width: size + 16, height: size + 16 }}
      >
        <Tv size={size} strokeWidth={2.4} />
      </div>
      {showText && (
        <div className="leading-none">
          <div className="text-tv-cyan font-extrabold tracking-wide" style={{ fontSize: size }}>
            TVVerse
          </div>
          <div className="text-tv-muted uppercase font-bold" style={{ fontSize: 8, letterSpacing: 2.5 }}>
            MediaVerse Labs
          </div>
        </div>
      )}
    </div>
  );
}
